const Style = {

  link: 'block text-blue-500 underline mb-4'

} 

export default Style;